// src/utils/fetchFilterMetadata.ts
// Reusable function to fetch filter metadata from Supabase Edge Function

export async function fetchFilterMetadata({ endpointUrl, jwt }: { endpointUrl: string; jwt: string; }) {
  const response = await fetch(endpointUrl, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${jwt}`,
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || 'Failed to fetch filter metadata');
  }
  return response.json();
}
